<template>
	<div class="right-nav">
		<div class="item" @click="pageTo('cart')" v-if="cartshow">
			<img src="@/assets/r1.png" alt="" />
			<i v-if="cartNumber>0">{{cartNumber}}</i>
			<p>购物车</p>
		</div>
		<div class="item" @click="pageTo('user')" v-if="usershow">
			<img src="@/assets/r2.png" alt="" />
			<p>我的</p>
		</div>
		<div class="item" @click="backToTop">
			<img src="@/assets/r3.png" alt="" />
			<p>回顶部</p>
		</div>
	</div>
</template>
<script>
	import {
		mapState
	} from 'vuex'
	export default {
		name: "navigation",
		props: {
			cartshow: {
				type: Boolean,
				default: true
			},
			usershow: {
				type: Boolean,
				default: true
			},

		},
		data() {
			return {

			};
		},
		created() {

		},
		computed: {
			...mapState(['cartNumber'])
		},
		methods: {
			pageTo(url) {
				this.$router.push({
					path: url,
				});
			},
			// 回到顶部
			backToTop() {
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				})
			}
		},
	};
</script>
<style lang="less" scoped>
	@color: #FF6A00;

	.right-nav {
		background-color: #fff;
		position: fixed;
		top: 50%;
		transform: translateY(-50%);
		right: 0;
		border-top-left-radius: 20px;
		border-bottom-left-radius: 20px;
		z-index: 100;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: space-between;
		text-align: center;
		padding: 10px 15px;
		border: 1px solid #ccc;
		border-right: none;

		.item {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			justify-content: space-between;
			text-align: center;
			padding: 10px 0;
			cursor: pointer;
			position: relative;

			i {
				position: absolute;
				top: 10px;
				left: 20px;
				font-size: 12px;
				background-color: @color;
				color: #fff;
				padding: 0 5px;
				border-radius: 8px;
				display: block;
				height: 16px;
				line-height: 16px;
			}

			img {
				width: 24px;
				height: 24px;
			}

			p {
				font-size: 14px;
				color: #3F3F3F;
				height: 20px;
				line-height: 20px;
				margin-top: 5px;
			}

		}
	}
</style>